// Australian date formatting helpers (display only).
// Storage/APIs continue to use ISO/UTC — these functions only change presentation.

function toDate(v) {
  if (!v) return null;
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  if (typeof v === "string") {
    // Plain date "YYYY-MM-DD" -> build a local date to avoid timezone shifting the day.
    const m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}

const pad = (n) => String(n).padStart(2, "0");

// DD-MM-YYYY
export function formatDate(v) {
  const d = toDate(v);
  if (!d) return v || "—";
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

// DD-MM-YYYY h:mm AM/PM (12-hour)
export function formatDateTime(v) {
  const d = toDate(v);
  if (!d) return v || "—";
  let h = d.getHours();
  const min = pad(d.getMinutes());
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${formatDate(d)} ${h}:${min} ${ap}`;
}

// Long, weekday-first (e.g. "Thursday, 2 July 2026") — already AU day/month order.
export function formatDateLong(v) {
  const d = toDate(v) || new Date();
  return d.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
}
